export default __webpack_public_path__ + "static/SR France - Process Flow Chart - Caramel Colorants-1e7fea3b207bac2a6c8a38aff44f0804.pdf";